export interface ExperienceReservationMetadata {
  reservationExpiresAt?: string
  reservationToken?: string
  returnUrl?: string
}

export function getExperienceReservationMetadata(item: App.Checkout.AnyItem): ExperienceReservationMetadata | undefined {
  if (item.itemType !== 'experience') return undefined

  const providerBookingData = item.metaData?.providerBookingData
  if (!providerBookingData || typeof providerBookingData !== 'object') return undefined

  const data = providerBookingData as Record<string, unknown>
  if (typeof data.reservationToken !== 'string' || typeof data.reservationExpiresAt !== 'string') return undefined

  return {
    reservationExpiresAt: data.reservationExpiresAt,
    reservationToken: data.reservationToken,
    returnUrl: typeof data.returnUrl === 'string' ? data.returnUrl : undefined,
  }
}

export function hasExperienceReservationMetadata(item: App.Checkout.AnyItem): boolean {
  return !!getExperienceReservationMetadata(item)
}

export function isExperienceReservationExpired(
  metadata: ExperienceReservationMetadata | undefined,
  now: number = Date.now(),
): boolean {
  const expiresAt = metadata?.reservationExpiresAt ? Date.parse(metadata.reservationExpiresAt) : NaN
  return Number.isFinite(expiresAt) && expiresAt <= now
}
